import { Heart, ShoppingBag, Star } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { addToCart } from "../lib/cart";
import { Currency, formatMoney } from "../lib/currency";
import { t } from "../lib/i18n";

export type Product = { id: number; slug: string; title: string; price: number; compare_at_price?: number; image?: string; category?: string; rating?: number; badge?: string };

export default function ProductCard({ product, currency }: { product: Product; currency: Currency }) {
  const { lang = "en" } = useParams();
  return (
    <article className="group overflow-hidden rounded-[24px] border border-[rgba(15,23,42,0.08)] bg-white shadow-[0_18px_45px_rgba(15,23,42,0.07)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_28px_70px_rgba(15,23,42,0.12)]">
      <Link to={`/${lang}/products/${product.slug}`} className="relative block aspect-[4/5] overflow-hidden bg-[#EFE6D8]">
        <span className="absolute left-4 top-4 z-10 rounded-full bg-white/90 px-3 py-1 text-xs font-black text-[#0F172A] shadow-[0_10px_22px_rgba(15,23,42,0.10)]">{product.badge || "NEW"}</span>
        <img src={product.image || "/placeholder.webp"} alt={product.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
      </Link>
      <div className="space-y-4 p-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#C89B5C]">{product.category || "Featured"}</p>
          <Link to={`/${lang}/products/${product.slug}`} className="mt-2 line-clamp-2 text-base font-black text-[#0F172A]">{product.title}</Link>
          <div className="mt-3 flex items-center gap-1 text-[#D8A85F]">
            {Array.from({ length: 5 }).map((_, index) => <Star key={index} size={14} fill="currentColor" />)}
            <span className="ml-1 text-xs font-semibold text-slate-500">{product.rating || 4.8}</span>
          </div>
        </div>
        <div className="flex items-center justify-between gap-3">
          <div><span className="text-lg font-black text-[#0F172A]">{formatMoney(product.price, currency)}</span> {product.compare_at_price && <span className="ml-1 text-sm text-slate-400 line-through">{formatMoney(product.compare_at_price, currency)}</span>}</div>
          <div className="flex gap-2">
            <button className="rounded-full border border-[rgba(15,23,42,0.10)] bg-white p-2.5 hover:text-[#C89B5C]" aria-label="Wishlist"><Heart size={18} /></button>
            <button className="rounded-full bg-[#0F172A] p-2.5 text-white shadow-[0_12px_24px_rgba(15,23,42,0.16)] hover:bg-[#16362f]" aria-label={t(lang, "addToCart")} title={t(lang, "addToCart")} onClick={() => addToCart({ productId: product.id, slug: product.slug, title: product.title, image: product.image, price: product.price, quantity: 1 })}><ShoppingBag size={18} /></button>
          </div>
        </div>
      </div>
    </article>
  );
}
